"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var ExpandMore_1 = __importDefault(require("@mui/icons-material/ExpandMore"));
var mountIsland_1 = require("../mountIsland");
var AccordionItem = function (_a) {
    var question = _a.question, answer = _a.answer;
    var _b = (0, react_1.useState)(false), isOpen = _b[0], setIsOpen = _b[1];
    return (react_1.default.createElement(material_1.Accordion, { expanded: isOpen, onChange: function () { return setIsOpen(!isOpen); }, disableGutters: true, sx: {
            mb: '5px',
            boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
            '&:before': { display: 'none' },
        } },
        react_1.default.createElement(material_1.AccordionSummary, { expandIcon: react_1.default.createElement(ExpandMore_1.default, { sx: { color: 'white' } }), sx: {
                bgcolor: 'secondary.dark',
                backgroundColor: '#281049',
                color: 'white',
                borderRadius: isOpen ? '5px 5px 0 0' : '5px',
                fontSize: '15px',
                '&:hover': {
                    backgroundColor: '#281049',
                },
            } },
            react_1.default.createElement(material_1.Typography, { sx: { fontSize: '15px' } }, question)),
        react_1.default.createElement(material_1.AccordionDetails, { sx: {
                bgcolor: isOpen ? '#f7f7f7' : 'white',
                borderLeft: isOpen ? '5px solid' : 'none',
                borderColor: 'secondary.main',
                borderRadius: '0 0 5px 5px',
                p: '0 18px',
            } },
            react_1.default.createElement(material_1.Typography, { sx: { p: '10px', m: 0, fontSize: '14px', color: '#333' } }, answer))));
};
var GetFAQs = function () {
    var _a;
    var faqsElement = document.getElementById('faqs');
    var faqs = faqsElement ? JSON.parse((_a = faqsElement.getAttribute('data-faqs')) !== null && _a !== void 0 ? _a : '[]') : [];
    return (react_1.default.createElement(material_1.Box, { sx: { maxWidth: '90%', mx: 'auto', p: '20px' } }, faqs.map(function (faq, index) { return (react_1.default.createElement(AccordionItem, { key: index, question: faq.question, answer: faq.answer })); })));
};
var faqsContainer = document.getElementById('faqs');
if (faqsContainer) {
    (0, mountIsland_1.mountIsland)(faqsContainer, react_1.default.createElement(GetFAQs, null));
}
